import { Link } from 'react-router-dom';

import { OrgPicker } from '../components/OrgPicker.tsx';
import { OnboardingBanner } from '../snapshot/components/OnboardingBanner.tsx';

import { SettingsIntegrations } from './SettingsIntegrations.tsx';
import { SettingsRepositories } from './SettingsRepositories.tsx';

/**
 * /data-sources/integrations — the "Integrations" area of the data-sources
 * shell. Reorganizes the existing, fully-wired integration surfaces into
 * one page that matches the wireframe (linked repos · available repos ·
 * link new repo):
 *   - {@link SettingsRepositories}: linked repos (with backfill /
 *     onboarding controls) + repos available via the GitHub App.
 *   - {@link SettingsIntegrations}: provider connections — GitHub App
 *     installs and the GitLab / Azure token-connect form.
 *
 * Both read the active org from the shell's Outlet context, so they work
 * unchanged here. "Link New Repo" opens the in-shell link-repo page
 * (/setup/link-repo), keeping the user inside the settings menu.
 */
export function DataSourcesIntegrations() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {/* Linking a repo kicks an onboarding run; the banner gives on-page
          feedback (null when no run is active). Sits above the H1. */}
      <OnboardingBanner />
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div>
          <h1 className="settings-h1">Integrations</h1>
          <p className="settings-subtitle">Manage &amp; configure existing integrations.</p>
        </div>
        <Link
          to="/setup/link-repo"
          className="snap-toolbar__btn"
          style={{ flexShrink: 0, textDecoration: 'none' }}
        >
          Link New Repo
        </Link>
      </div>

      <OrgPicker />

      <section>
        <SettingsRepositories />
      </section>
      <section>
        <SettingsIntegrations />
      </section>
    </div>
  );
}
